import React from 'react';
import PropTypes from 'prop-types';
import MainTopBar from '../MainLayout/Header/TopBar';
import FormTopBar from './Header/TopBar';
import Container from '@material-ui/core/Container';
import Footer from '../Footer/Footer';

const FormLayout = ({ children }) => (
  <>
    <MainTopBar />
    <FormTopBar />
    <Container maxWidth="xl">{children}</Container>
    <Footer />
  </>
);

FormLayout.propTypes = {
  children: PropTypes.node,
};

export default FormLayout;
